var _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Outline",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.09,42.89a2.45,2.45,0,0,0-.72,1.75,2.47,2.47,0,0,0,2.46,2.47H86V24.91a2.47,2.47,0,1,0-4.93,0V38.68h0L69.41,27a32.49,32.49,0,1,0,0,46L65.93,69.5a27.56,27.56,0,1,1,0-39L77.59,42.17H63.83A2.44,2.44,0,0,0,62.09,42.89Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "41.22 36.7 41.1 54.38 56.52 63.19 58.75 59.28 45.62 51.77 45.72 36.73 41.22 36.7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdate);
export default __webpack_public_path__ + "static/media/Update.a69583500c921e580caf745a7937ceb7.svg";
export { ForwardRef as ReactComponent };